export default __webpack_public_path__ + "static/media/WNo.7-6.03410469.jpg";